import Component from '@glimmer/component';
import { getOwner } from '@ember/application';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{! template-lint-disable no-forbidden-elements }}\n<style type=\'text/css\'>{{this.layerOpen}}{{yield}}{{this.layerClose}}</style>\n");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — a runtime <style> block for CLASSIC-only rules
 *              (tenant colours, per-page tweaks) that must keep the cascade
 *              outcome it always had against the classic stylesheet
 *   extends:   Component (@glimmer/component)
 *   template:  bb-classic-style.hbs (yields the CSS text)
 *   args:      none (block content = the CSS rules)
 *   uses:      @ember/application (getOwner) — optional lookup of service:ui
 *   siblings:  bb-tenant-palette (the other runtime <style> of the shell);
 *              apps/beebeeboard-medical app/styles/app.scss (compiles classic
 *              inside `@layer classica`) and vite.config.mjs
 *              layerVendorCssInClassica
 *   tests:     -
 *   gotchas:   an app that enabled the «UI nuova» switch (`ui.enabled`, its own
 *              instance-initializer) compiles its classic CSS inside
 *              `@layer classica` (MIGRATION-PLAN.md §1.3, step 0.3). A plain
 *              <style> is UNLAYERED there and would beat every classic rule,
 *              even the higher-specificity ones it used to lose to; so in that
 *              app the block is wrapped in `@layer classica { … }`, where
 *              specificity and source order decide exactly as before. In every
 *              other app classic is unlayered and the block must stay
 *              unlayered too (a layered block would lose to all of classic):
 *              no wrap. The layer name must match app.scss.
 *
 * Plan: docs/ui-nuova/MIGRATION-PLAN.md §1.3 (step 0.3).
 */
class BbClassicStyleComponent extends Component {
  get layered() {
    return Boolean(getOwner(this).lookup('service:ui')?.enabled);
  }
  get layerOpen() {
    return this.layered ? '@layer classica {' : '';
  }
  get layerClose() {
    return this.layered ? '}' : '';
  }
}
setComponentTemplate(TEMPLATE, BbClassicStyleComponent);

export { BbClassicStyleComponent as default };
//# sourceMappingURL=bb-classic-style.js.map
